'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mixins = exports.Scatter = exports.Bubble = exports.Radar = exports.PolarArea = exports.Pie = exports.Line = exports.Doughnut = exports.HorizontalBar = exports.Bar = exports.VueCharts = undefined;

var _Bar = require('./BaseCharts/Bar');

var _Bar2 = _interopRequireDefault(_Bar);

var _HorizontalBar = require('./BaseCharts/HorizontalBar');

var _HorizontalBar2 = _interopRequireDefault(_HorizontalBar);

var _Doughnut = require('./BaseCharts/Doughnut');

var _Doughnut2 = _interopRequireDefault(_Doughnut);

var _Line = require('./BaseCharts/Line');

var _Line2 = _interopRequireDefault(_Line);

var _Pie = require('./BaseCharts/Pie');

var _Pie2 = _interopRequireDefault(_Pie);

var _PolarArea = require('./BaseCharts/PolarArea');

var _PolarArea2 = _interopRequireDefault(_PolarArea);

var _Radar = require('./BaseCharts/Radar');

var _Radar2 = _interopRequireDefault(_Radar);

var _Bubble = require('./BaseCharts/Bubble');

var _Bubble2 = _interopRequireDefault(_Bubble);

var _Scatter = require('./BaseCharts/Scatter');

var _Scatter2 = _interopRequireDefault(_Scatter);

var _index = require('./mixins/index.js');

var _index2 = _interopRequireDefault(_index);

var _package = require('../package.json');

var _package2 = _interopRequireDefault(_package);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VueCharts = {
  version: _package2.default.version,
  Bar: _Bar2.default,
  HorizontalBar: _HorizontalBar2.default,
  Doughnut: _Doughnut2.default,
  Line: _Line2.default,
  Pie: _Pie2.default,
  PolarArea: _PolarArea2.default,
  Radar: _Radar2.default,
  Bubble: _Bubble2.default,
  Scatter: _Scatter2.default,
  mixins: _index2.default
};

exports.default = VueCharts;
exports.VueCharts = VueCharts;
exports.Bar = _Bar2.default;
exports.HorizontalBar = _HorizontalBar2.default;
exports.Doughnut = _Doughnut2.default;
exports.Line = _Line2.default;
exports.Pie = _Pie2.default;
exports.PolarArea = _PolarArea2.default;
exports.Radar = _Radar2.default;
exports.Bubble = _Bubble2.default;
exports.Scatter = _Scatter2.default;
exports.mixins = _index2.default;


//////////////////
// WEBPACK FOOTER
// ./~/vue-chartjs/es/index.js
// module id = 638
// module chunks = 3